import { createAction, PayloadActionCreator } from '@reduxjs/toolkit';
import { ErrorResponse } from '../common/PricePrgClient';

export type AsyncActionCreator<TRequestPayload, TResponsePayload, TErrorPayload> = {
    request: PayloadActionCreator<TRequestPayload, string>;
    success: PayloadActionCreator<TResponsePayload, string>;
    failure?: PayloadActionCreator<TErrorPayload, string>;
};

export function createAsyncAction<TRequestPayload, TResponsePayload, TErrorPayload>(
    namespace: string,
    name: string,
    handleFailure?: true
): {
    request: PayloadActionCreator<TRequestPayload, string>;
    success: PayloadActionCreator<TResponsePayload, string>;
    failure: PayloadActionCreator<TErrorPayload, string>;
};

export function createAsyncAction<TRequestPayload, TResponsePayload>(
    namespace: string,
    name: string,
    handleFailure?: false
): {
    request: PayloadActionCreator<TRequestPayload, string>;
    success: PayloadActionCreator<TResponsePayload, string>;
};

export function createAsyncAction<TRequestPayload, TResponsePayload, TErrorPayload = ErrorResponse>(
    namespace: string,
    name: string,
    handleFailure = true
) {
    const prefix = `@${namespace}/${name}`;
    const asyncActionCreator = {
        request: createAction<TRequestPayload, string>(`${prefix}Request`),
        success: createAction<TResponsePayload, string>(`${prefix}Success`)
    };

    if (handleFailure) {
        return {
            ...asyncActionCreator,
            failure: createAction<TErrorPayload>(`${prefix}Failure`)
        };
    }

    return asyncActionCreator;
}

/* TODO: Create a function for creating multiple async functions for same namespace,
 * instead of having to call createAsyncAction with the same namespace for every async action.
 * Should be used like something like this. Not sure how to infer the types returned from the method,
 * hence the reason it is not implemented.
 *
export const {fetchUserGroups, createUserGroups} = createAsyncActions(namespaces.userGroups,
    builder => builder
        .create<void, UserGroupDto[]>('fetchUserGroups')
        .create<void, UserGroupDto[]>('createUserGroup')
);
*/
